import { createContext, ReactNode, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

import { createCookieConsentConfig } from 'src/cookieConsent/config';

const CookieConsentContext = createContext({ revision: 0 });

export function useCookieConsentRevision(): number {
  return useContext(CookieConsentContext).revision;
}

interface Props {
  children: ReactNode;
}

export default function CookieConsentProvider({ children }: Props) {
  const [revision, setRevision] = useState(0);
  const bump = useCallback(() => setRevision(r => r + 1), []);
  const {
    i18n: { resolvedLanguage },
  } = useTranslation();
  const languageRef = useRef(resolvedLanguage ?? 'hu');
  languageRef.current = resolvedLanguage ?? 'hu';

  useEffect(() => {
    let active = true;
    void CookieConsent.run(createCookieConsentConfig(bump)).then(() => {
      if (active) {
        void CookieConsent.setLanguage(languageRef.current);
      }
    });
    return () => {
      active = false;
      CookieConsent.reset(true);
    };
  }, [bump]);

  useEffect(() => {
    void CookieConsent.setLanguage(resolvedLanguage ?? 'hu');
  }, [resolvedLanguage]);

  return (
    <CookieConsentContext.Provider value={{ revision }}>{children}</CookieConsentContext.Provider>
  );
}
